module.exports = __webpack_public_path__ + "static/media/chatgpt.bb11b611.svg";